(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.directive('viewsDropdown', [                
        'ViewsService',
        '$state',
        'ViewsBroadcast',
        '$rootScope',
        ViewsDropdown
    ]);
    
    function ViewsDropdown(ViewsService, $state, ViewsBroadcast, $rootScope) {
        var directive = {
            link: link,
            restrict: 'E',
            templateUrl: '/app/global/components/views-dropdown/views-dropdown.html'
        };
        return directive;

        function link(scope, element) {

            let views = ViewsService.getViews().filter(view => view.forOperators === $rootScope.isRingfoon);                        
            setViews(views);

            scope.currentView = ViewsService.getCurrentView();
            
            scope.select = function select(view) {
                if (scope.currentView && 
                    view.id !== scope.currentView.id) {
                      
                        scope.currentView = view;
                        ViewsService.setCurrentView(view);  
                        $state.go('Home.Agenda_Day', {}, { reload: $state.current.name });
                    };
                }

            listen();

            function listen() {
                var viewsChangedListener = scope.$on(ViewsBroadcast.ViewsRefreshed, function () {
                    var views = ViewsService.getViews();
                    setViews(views);
                    scope.currentView = ViewsService.getCurrentView();                    
                });

                var viewSelectedListener = scope.$on(ViewsBroadcast.ViewSelected, function (event, view) {
                    var selectedView = views.filter(v => v.id === view.id)[0];
                    if (selectedView && 
                        selectedView.id !== scope.currentView.id) {
                        scope.currentView = selectedView;
                        $state.go('Home.Agenda_Day', {}, { reload: $state.current.name });
                    }
                });

                // destroy
                scope.$on("$destroy", function () {
                    if (viewsChangedListener) {
                        viewsChangedListener();
                        viewsChangedListener = null;
                    }

                    if (viewSelectedListener) {
                        viewSelectedListener();
                    }
                });
            }
            
            function setViews(views) {
                scope.userViews = views.filter(view => view.forOperators === false);
                scope.operatorViews = views.filter(view => view.forOperators === true);
                if ($rootScope.isRingfoon){
                    if (!scope.operatorViews || scope.operatorViews.length === 0){
                        scope.userViews = [ViewsService.getDefaultView($rootScope.isRingfoon)]
                    }else{
                        // don't show userviews if we have operator views for simplicity
                        scope.userViews = [];
                    }
                }
            }
        }
    }
})();